<!-- 独属于VSS的生产商选择器 -->
<template>
    <div class="mc-supplier--select">
        <mc-select
            v-model="innerValue"
            :source="source"
            :disabled="disabled"
            :clearable="clearable"
            :filterable="true"
            :multiple="multiple"
            collapse-tags
            :placeholder="placeholder"
            v-bind="$attrs"
            @input="input"
            @change="change"
        />
    </div>
</template>
<script>
import {
    defineComponent,
    ref,
    watch,
} from '@vue/composition-api';

export default defineComponent({
    name: 'McSupplierSelect',
    props: {
        value: {
            type: [String, Number, Array],
            default: '',
        },
        // 数据处理函数，返回值会被作为渲染下拉列表的数据
        responseProcessor: {
            type: Function,
            default: (res) => res,
        },
        // 选项值的数据类型
        valueType: {
            type: String,
            default: 'string',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        placeholder: {
            type: String,
            default: '请选择生产商',
        },
        extendsApiParams: {
            type: Object,
            default: () => ({})
        }
    },
    setup(props, ctx) {
        const innerValue = ref(props.value);

        // 根据valueType格式化选项值的数据类型
        const formatValueToType = (val, type) => {
            if (!type || val === '' || val === undefined || val === null) {
                // 没有类型/空值
                return val;
            } else {
                // 设置数据类型为type类型
                return type === 'number' ? +val : `${val}`;
            }
        };

        const buildParams = (params, extendsParams) => {
            if (extendsParams.query) {
                params.producerName = extendsParams.query;
            } else if (props.value && !Array.isArray(props.value)) {
                // 接口模糊搜索字段类型限制为String
                params.producerId = String(props.value);
            }
            return params;
        };

        const responseProcessor = (res) => {
            const producers = (res.infoList || []).map((item) => ({
                ...item,
                label: item.name,
                value: formatValueToType(item.id, props.valueType),
            }));
            ctx.emit('loaded', producers);
            if (typeof props.responseProcessor === 'function') {
                return props.responseProcessor(producers);
            } else {
                return producers;
            }
        };

        const source = {
            ajax: {
                type: 'hPost',
                url: '/api/vss/shepherd/sqm/producer/getProducerGPage',
                params: {
                    ...props.extendsApiParams,
                    producerName: '', // 搜索字段:名称模糊搜索,id精确搜索
                    page: { offset: 0, limit: 100 },
                },
            },
            responseProcessor,
            buildParams,
        };

        watch(() => props.value, (val) => {
            innerValue.value = val;
        }, { immediate: true });

        const input = (val) => {
            ctx.emit('input', val);
        };

        const change = (val, item) => {
            ctx.emit('change', val, item);
        };

        return {
            innerValue,
            source,
            input,
            change,
        };
    },
});
</script>
